import React from 'react';

/**
 * Skeleton-Zustand der Event-Timeline während des Ladens.
 */
const TimelineSkeleton: React.FC = () => (
  <div className="relative pl-8 sm:pl-12 pt-6 animate-pulse" aria-hidden="true">
    {/* Vertikale Linie */}
    <div className="absolute left-3 sm:left-5 top-0 bottom-0 w-px sm:w-0.5 bg-zinc-800" />

    {/* Monats-Header-Skeleton */}
    <div className="h-6 w-40 bg-zinc-800 rounded-lg mb-5" />

    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="relative mb-4">
        <span className="absolute -left-[26px] sm:-left-[33px] top-6 w-3 h-3 rounded-full bg-zinc-800 border-2 border-zinc-950" />
        <div className="rounded-2xl bg-zinc-900 border border-zinc-800 overflow-hidden">
          <div className="flex flex-col sm:flex-row">
            <div className="w-full h-36 sm:w-44 sm:h-auto sm:min-h-[150px] flex-shrink-0 bg-zinc-800" />
            <div className="flex-1 p-4 space-y-3">
              <div className="flex gap-2">
                <div className="h-4 w-14 bg-zinc-800 rounded-full" />
                <div className="h-4 w-20 bg-zinc-800 rounded-full" />
              </div>
              <div className="h-5 w-3/4 bg-zinc-800 rounded-lg" />
              <div className="h-3.5 w-1/2 bg-zinc-800 rounded-lg" />
              <div className="h-3.5 w-2/5 bg-zinc-800 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default TimelineSkeleton;
